import {
    GET_LIST,
    GET_ONE,
    CREATE,
} from "react-admin";


import {
    FirebaseDataProvider
} from "react-admin-firebase";
import firebase from 'firebase';
import { firebaseConfig } from '../FIREBASE_CONFIG';
const firebaseApp = firebase.apps[0];
const options = {
    logging: true,
    // rootRef: 'rootrefcollection/QQG2McwjR2Bohi9OwQzP',
    app: firebaseApp,
    watch: ['people'],
    // dontwatch: ['comments'];
    persistence: 'local',
    // disableMeta: true
    dontAddIdFieldToDoc: true
};

const dataProvider = FirebaseDataProvider(firebaseConfig, options);

const resource='people';

class PeopleStore {

    async save(person) {
        return dataProvider(CREATE, resource, {data: person});
    }

    findAll() {
       return dataProvider(GET_LIST, resource, {pagination: {page: 1, perPage: 99999}});
    }

    async findById(id) {
        return dataProvider(GET_ONE, resource, {id: id});
    }

    findOne(filter) {
        return dataProvider(GET_ONE, resource, filter);
    }

    findByFieldOperatorId(operatorId) {
        var filter ={filter: {operatorId: operatorId}, pagination: {page: 1, perPage: 1}};
        return this.getList(filter);
    }
    getList(filter) {
        return dataProvider(GET_LIST, resource, filter);
    }
}

export default PeopleStore;

